import React from 'react';
import { Box, Typography } from '@mui/material';

// React only supports error boundaries as class components.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled UI error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "24px",
          textAlign: "center",
        }}>
          <Typography sx={{ fontSize: "24px", marginBottom: "16px" }}>
            Ocorreu um erro inesperado
          </Typography>
          <Typography sx={{ fontWeight: "normal" }}>
            Tente recarregar a página. Se o problema persistir, contate o suporte.
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}
